import React from 'react'
import avatar from "../../images/img/avatar.jpg"
import moment from 'moment';
import styled from 'styled-components';

const Container = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    border-radius: 10px;

    .right-side{
        width: calc(100% - 60px);
        display: flex;
        align-items: center;
        gap: 10px;
        background-color: ${({theme}) => theme.secondaryBgColor};
        padding: 20px;
        border-radius: 10px;
        position: relative;

        img{
            width: 50px;
            height: 50px;
            border-radius: 50%;
            object-fit: cover;
        }


        .content-wrapper{
            display: flex;
            flex-direction: column;
            gap: 10px;
            color: ${({theme}) => theme.mainTextColor};
            
            .phone-number{
                font-size: 13px;
                font-weight: var(--font-weight-xl);
                color: var(--color-main);
            }
            
            .message-text{
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-lg);
            }

            .date{
                font-size: 13px;
                font-weight: var(--font-weight-lg);

            }
        }
    }
`

const formatData = (data) => {
    return data
        .split("\r\n") // Satırları ayır
        .map(line => line.trim()) // Boşlukları temizle
        .filter(line => line && line !== "_________") // Boş satırları ve gereksiz çizgileri çıkar
        .map((line, index) => <p key={index}>{line}</p>); // JSX içine çevir
};

const AdminYukBulContainer = ({item}) => {
  return (
    <Container>
        <div className="right-side">
            <img src={avatar} alt="" />
            <div className="content-wrapper">
                <div className="phone-number">{item.phoneNumber}</div>
                <div className="message-text">{formatData(item.message)}</div>
                <div className="message-text">{moment(item.messageSentTime).format('LLL')}</div>
            </div>
        </div>
    </Container>
)
}

export default AdminYukBulContainer